"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _assets = require("./sub-components/assets");

var _assets2 = _interopRequireDefault(_assets);

var _modules = require("./sub-components/modules");

var _modules2 = _interopRequireDefault(_modules);

var _electrify = require("../../src/styles/electrify.css");

var _electrify2 = _interopRequireDefault(_electrify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElectrodeElectrifyReactComponent19 = function (_React$Component) {
		(0, _inherits3.default)(ElectrodeElectrifyReactComponent19, _React$Component);

		function ElectrodeElectrifyReactComponent19() {
				(0, _classCallCheck3.default)(this, ElectrodeElectrifyReactComponent19);
				return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}

		ElectrodeElectrifyReactComponent19.prototype.render = function render() {
				return _react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
								"div",
								{ className: _electrify2.default.leftColumn },
								_react2.default.createElement(_modules2.default, {
										pureWebpackStats: this.props.webpackInfo.pureWebpackStats,
										modulesByPkg: this.props.webpackInfo.modulesByPkg,
										totalSize: this.props.webpackInfo.totalSizeByPkg
								})
						),
						_react2.default.createElement(
								"div",
								{ className: _electrify2.default.rightColumn },
								_react2.default.createElement(_assets2.default, { webpackInfo: this.props.webpackInfo })
						)
				);
		};

		return ElectrodeElectrifyReactComponent19;
}(_react2.default.Component);

exports.default = ElectrodeElectrifyReactComponent19;


ElectrodeElectrifyReactComponent19.displayName = "ElectrodeElectrifyReactComponent19";

ElectrodeElectrifyReactComponent19.propTypes = {};

ElectrodeElectrifyReactComponent19.defaultProps = {};


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/components/electrode-electrify-react-component.js
// module id = 417
// module chunks = 0